import { useEffect } from 'react';
import { useRealtime } from '@/contexts/RealtimeContext';
import { useBudget } from '@/contexts/BudgetContext';

/**
 * Hook to connect real-time updates with budget data
 * Place this in a component that has access to both contexts
 */
export function useRealtimeSync() {
  const { addListener, checkBudgetAlerts } = useRealtime();
  const { 
    handleRealtimeTransactionUpdate, 
    handleRealtimeSettingsUpdate,
    getCategorySpending,
    budgetGoals,
    formatMoney,
  } = useBudget();

  // Listen for transaction changes
  useEffect(() => {
    const unsubscribe = addListener('transaction', (payload) => {
      handleRealtimeTransactionUpdate(payload);
      
      // Check budget alerts after transaction update
      setTimeout(() => {
        const spending = getCategorySpending();
        checkBudgetAlerts(spending, budgetGoals, formatMoney);
      }, 500);
    });

    return unsubscribe;
  }, [addListener, handleRealtimeTransactionUpdate, getCategorySpending, budgetGoals, formatMoney, checkBudgetAlerts]);

  // Listen for settings changes
  useEffect(() => {
    const unsubscribe = addListener('settings', handleRealtimeSettingsUpdate);
    return unsubscribe;
  }, [addListener, handleRealtimeSettingsUpdate]);
}
